// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2681":"be8c4a18","3767":"4240402b","7850":"f9254a1b"}[chunkId] + ".chunk.css";
};